<top-banner variant="small"></top-banner>

<div class="main-content">
  <div class="row">
    <div class="col-md-12">
      <div class="card certificate-approval-page">
        <div class="row">
          <div *ngIf="tabitems && tabitems.length" class="col-md-2 cardtabs-wrapper">
            <app-card-tabs [tabitems]="tabitems"></app-card-tabs>
          </div>
          <div [class]="tabitems && tabitems.length ? 'col-md-10' : 'col-md-12'">
            <div *ngIf="workflowItem" class="certificate-approval-content mb-2 animated fadeIn">
              <div class="certificate-approval-title">
                <i class="far fa-edit"></i>
                <h3 class="mb-0">{{ title }}</h3>
              </div>

              <div class="certificate-approval-meta">
                <h5 class="certificate-approval-name mb-2">
                  Contractor:
                  <a
                    *ngIf="canOpenContractorLink; else plainContractorName"
                    [routerLink]="contractorLink"
                    style="color: inherit; text-decoration: underline;">
                    <strong>{{ contractorWorkflowItem.maintenanceName }}</strong>
                  </a>
                  <ng-template #plainContractorName>
                    <strong>{{ contractorWorkflowItem.maintenanceName }}</strong>
                  </ng-template>
                </h5>
              </div>

              <div class="certificate-approval-details">
                <h6>Details</h6>
                <ng-container *ngIf="workflowItem">
                  Requested by: <username-display [userName]="workflowItem.createdBy"></username-display>
                  <div *ngIf="workflowItem.status === 'REJECTED'" class="mt-2">
                    Reason for Rejection:
                    <span>{{ contractorWorkflowItem.comments || 'No reason provided' }}</span>
                  </div>
                </ng-container>
              </div>

              <p-table [value]="[workflowItem]" [autoLayout]="true" class="certificate-approval-table">
                <ng-template pTemplate="header">
                  <tr>
                    <th>Type</th>
                    <th>Files</th>
                    <th *ngIf="showExpiryDateColumn">Expiry Date</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-comp>
                  <tr [pSelectableRow]="comp">
                    <td>{{ comp.competencyType }}</td>
                    <td>
                      <div *ngFor="let file of comp.files" class="certificate-file-row">
                        <span>{{ file.fileName }}</span>
                        <button type="button" class="btn btn-primary btn-round-action" (click)="viewDocument(file.fileName)">View File</button>
                      </div>
                    </td>
                    <td *ngIf="showExpiryDateColumn">{{ comp.expiryDate | date: 'MMM d, y' }}</td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage" let-columns>
                  <tr>
                    <td [attr.colspan]="showExpiryDateColumn ? 3 : 2">No certificates found</td>
                  </tr>
                </ng-template>
              </p-table>

              <div class="certificate-approval-actions" *ngIf="!showRejectionForm && !showApprovalForm && !isViewOnly">
                <button type="submit" class="btn btn-success btn-round btn-round-action" [disabled]="saveInProgress" (click)="approve()">Approve</button>
                <button type="submit" class="btn btn-danger btn-round btn-round-action" [disabled]="saveInProgress" (click)="reject()">Reject</button>
              </div>

              <ng-container *ngIf="showRejectionForm && !isViewOnly">
                <div class="certificate-approval-rejection-intro alert alert-warning" role="alert">
                  <p class="mb-0"><b>Let the Contractor Manager know why this was rejected</b></p>
                </div>

                <div class="form-row certificate-approval-rejection-form">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label>Comment</label>
                      <textarea type="text" class="form-control certificate-approval-rejection-textarea" [(ngModel)]="rejectionForm"></textarea>
                    </div>
                  </div>
                </div>
                <div class="certificate-approval-actions">
                  <button type="submit" class="btn btn-success btn-round btn-round-action" [disabled]="saveInProgress" (click)="saveRejection()">Reject</button>
                  <button type="button" class="btn btn-link btn-link-cancel" [disabled]="saveInProgress" (click)="cancelRejection()">
                    <i class="fas fa-times"></i>
                    Cancel
                  </button>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
